import {slyHorizontal} from '../../static/major/js/libs/sly/sly.horizontal';
import 'readmore-js/readmore';
import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/modal';
import DataLayerService from "datalayer-service";
import {getProductAndStoreDataFromHTMLAttributes} from "../analytics/cta";

import {ID as STAR_RATING_ID, renderStarComponent} from "..//react-components/star-rating.jsx";
import {ID as PROMO_BTN_ID, renderPromoButton} from "../react-components/promo/buttons/general.jsx";
import {
  ID as CASHBACK_BTN_ID,
  initCashbackPromoButtons
} from "../react-components/promo/buttons/cashback.jsx";
import {ID as SEND_BTN_ID, renderSendButton} from "../react-components/send-text/index.jsx";
import {ID as PHONE_BTN_ID, renderPhoneButton} from "../react-components/phone-button.jsx";
import {renderCustomerRating} from '../react-components/customer-rating';
import {renderCustomerRatingBar} from '../react-components/customer-rating-bar';

const STORE_TYPE = 'store';
const PRODUCT_TYPE = 'product';
let productQuickViewLoaded = false;
let storeQuickViewLoaded = false;

const dataLayerService = new DataLayerService(window);

function loadProductQuickViewModalContent() {
  document.removeEventListener('scroll', loadProductQuickViewModalContent);
  window.productQuickViewQueue = window.productQuickViewQueue || [];

  let promises = [];

  while (window.productQuickViewQueue.length > 0) {
    const productInfo = window.productQuickViewQueue.pop();
    const productData = {store: productInfo.s, retailer: productInfo.r, 'is_mobile': productInfo.m};

    promises.push(
      $.post(`/product-quick-view/${productInfo.p}/${productInfo.slug}/`, productData)
        .then(data => {
          const elem_id = `qv-${productInfo.slug}-${productInfo.p}`
          const element = document.getElementById(elem_id);
          element.innerHTML = data.content;
          renderStarComponent(`#${elem_id} ${STAR_RATING_ID}`);
          renderCustomerRating();
          renderCustomerRatingBar();

          return true;
        })
    );
  }
  productQuickViewLoaded = true;

  return promises;
}

function loadStoreQuickViewModalContent() {
  document.removeEventListener('scroll', loadStoreQuickViewModalContent);
  window.storeQuickViewQueue = window.storeQuickViewQueue || [];

  let promises = [];

  while (window.storeQuickViewQueue.length > 0) {
    const storeData = window.storeQuickViewQueue.pop();

    promises.push(
      $.get(`/api/v2/products/${storeData.storeSlug}/quick-view/`, {'location_page': storeData.location_page})
        .then(data => {
          const elem_id = `products-${storeData.storeSlug}-qv`
          const element = document.getElementById(elem_id);
          element.innerHTML = data.content;
          renderStarComponent(`#${elem_id} ${STAR_RATING_ID}`);
          renderPromoButton(`#${elem_id} #${PROMO_BTN_ID}`);
          initCashbackPromoButtons(`#${elem_id} #${CASHBACK_BTN_ID}`);
          renderSendButton(`#${elem_id} #${SEND_BTN_ID}`);
          renderPhoneButton(`#${elem_id} #${PHONE_BTN_ID}`)
          window.initStoreMapAsync(`${storeData.storeSlug}-map`, storeData.lat, storeData.lng);
          return true;
        })
    );
  }
  storeQuickViewLoaded = true;

  return promises;
}

const asyncLoaderFunctions = {
  product: loadProductQuickViewModalContent,
  store: loadStoreQuickViewModalContent
};

function showQuickView(slug, type) {
  // Type can be store and product.

  const modalID = `#${slug}-${type}-qv`;

  window.initializePopovers();

  const modal = $(modalID);
  modal.on('shown.bs.modal', () => {
    let slyFrame;

    $(`#${slug}-profile-pitch`).readmore({collapsedHeight: 60});

    if (type === STORE_TYPE) {
      slyFrame = $(`#${slug}-product-slider`);
    }

    if (type === PRODUCT_TYPE) {
      const ratingCircleID = document.getElementById(`model-rating-graphic--${slug}`);
      if (ratingCircleID) {
        ratingCircleID.setAttribute('r', 30);
      }
    }

    if (slyFrame) {
      const sly = slyHorizontal(slyFrame).data('sly');
      sly.reload();
    }
  });

  modal.modal('show');

  if (type === PRODUCT_TYPE) {
    $(`#pictures-gallery-${slug} .carousel-control`).on('click', function (e) {
      e.preventDefault();
      const slide = $(this).data('slide');
      $(`#pictures-gallery-${slug}`).carousel(slide);
    });

    $(`#videos-gallery-${slug} .carousel-control`).on('click', function (e) {
      e.preventDefault();
      const slide = $(this).data('slide');
      $(`#videos-gallery-${slug}`).carousel(slide);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!productQuickViewLoaded) {
    document.addEventListener('scroll', loadProductQuickViewModalContent);
  }

  if (!storeQuickViewLoaded) {
    document.addEventListener('scroll', loadStoreQuickViewModalContent);
  }
});

export const handleQuickViewClick = function (element, slug, type) {
  if (!productQuickViewLoaded || !storeQuickViewLoaded) {
    const asyncLoaderFunction = asyncLoaderFunctions[type];

    Promise.all(asyncLoaderFunction())
      .then(() => showQuickView(slug, type));
  } else {
    showQuickView(slug, type);
  }

  const {product, store} = getProductAndStoreDataFromHTMLAttributes(element);
  dataLayerService.productQuickViewEvent({
    pageRegion: element.getAttribute('data-page-region'),
    product: product,
    store: store
  })
};
